import { PasswordValidator, MinLengthRule } from "../../core/services/password-validator.service";

export class ResetPasswordController {
    constructor(passwordValidatorService) {
        'ngInject';
        this.passwordValidatorService = passwordValidatorService;
        this.passwordValidator = new PasswordValidator([
            new MinLengthRule(true, 0),
            new MinLengthRule(true, 12)
        ]);
        this.password = "";
    }

    loadValidator(userID, firstName, lastName) {
        this.passwordValidatorService.retrievePasswordValidator({
            EmployeeID: userID,
            FirstName: firstName,
            LastName: lastName
        }).then(validator => this.passwordValidator = validator);
    }
}
